import React from 'react';

const AllBuyers = () => {
    return (
        <div>
            <p>This  is buyers list</p>
        </div>
    );
};

export default AllBuyers;